import { render, staticRenderFns } from "./AddSeries.vue?vue&type=template&id=52804e0c"
import script from "./AddSeries.vue?vue&type=script&lang=js"
export * from "./AddSeries.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports